// /src/pages/BlogPost.jsx
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import blogData from '../data/blogData';

export default function BlogPost() {
  const { id } = useParams();
  const article = blogData.find(post => post.id === parseInt(id));
  const [likes, setLikes] = useState(0);
  const [dislikes, setDislikes] = useState(0);
  const [comments, setComments] = useState([]);
  const [form, setForm] = useState({ name: '', email: '', comment: '' });

  const handleVote = (type) => {
    if (type === 'up') setLikes(likes + 1);
    else setDislikes(dislikes + 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setComments([...comments, { ...form }]);
    setForm({ name: '', email: '', comment: '' });
  };

  if (!article) return <div className="container py-4">Article not found.</div>;

  const formattedContent = (article.fullContent || article.content)
    .replace(/\n?\s*(\d+)\.\s+(.*?)(?=\n|$)/g, '<h5 class="mb-1 mt-2">$1. $2</h5>')
    .replace(/\n?\s*[-\u2022]\s+(.*?)(?=\n|$)/g, '<li>$1</li>')
    .replace(/(<li>.*?<\/li>)/g, '<ul class="mb-1 ps-4">$1</ul>')
    .replace(/\n(?=\S)/g, '<p class="mb-1">') + '</p>';

  return (
    <div
      className="py-4 text-white"
      style={{
        backgroundImage: `url('/Jazuz-moving-truck.png')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        minHeight: '100vh'
      }}
    >
      <div className="container bg-dark bg-opacity-75 p-4 rounded">
        <h2>{article.title}</h2>
        <p className="text-muted">By {article.author}</p>
        <div style={{ whiteSpace: 'pre-line', lineHeight: '1.5' }} dangerouslySetInnerHTML={{ __html: formattedContent }} />

        <div className="d-flex align-items-center gap-3 my-3">
          <button onClick={() => handleVote('up')} className="btn btn-success">👍 {likes}</button>
          <button onClick={() => handleVote('down')} className="btn btn-danger">👎 {dislikes}</button>
        </div>

        <h4 className="mt-4">Leave a Comment</h4>
        <form onSubmit={handleSubmit} className="mb-3">
          <input type="text" className="form-control mb-2" placeholder="Name" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          <input type="email" className="form-control mb-2" placeholder="Email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          <textarea className="form-control mb-2" placeholder="Your comment" required value={form.comment} onChange={e => setForm({ ...form, comment: e.target.value })}></textarea>
          <button className="btn btn-primary">Post Comment</button>
        </form>

        <div>
          <h5>Comments</h5>
          {comments.length === 0 ? (
            <p className="text-muted">No comments yet. Be the first to comment!</p>
          ) : (
            comments.map((c, idx) => (
              <div key={idx} className="border rounded p-2 mb-2 bg-light text-dark">
                <p className="mb-1"><strong>{c.name}</strong> ({c.email})</p>
                <p className="mb-0">{c.comment}</p>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
